import { Eye, EyeClosed } from 'lucide-react';
import { useState } from 'react';

interface FloatingInputProps {
    label: string;
    type?: string;
    value: string;
    onChange: (value: string) => void;
    placeholder?: string;
    isPassword?: boolean;
}

const FloatingInput = ({ label, type = 'text', value, onChange, placeholder, isPassword = false }: FloatingInputProps) => {
    const [isFocused, setIsFocused] = useState(false);
    const isFloating = isFocused || value.length > 0;
    const [visible, setVisible] = useState<boolean>(false);

    return (
        <div className="relative w-full">
            <input
                type={isPassword ? (visible ? 'text' : 'password') : type}
                value={value}
                onChange={e => onChange(e.target.value)}
                onFocus={() => setIsFocused(true)}
                onBlur={() => setIsFocused(false)}
                placeholder={placeholder}
                className={`
          w-full px-4 py-3 rounded-xl border
          text-gray-800 bg-white
          transition-all duration-200 outline-none
          ${isFocused ? 'border-purple-500 shadow-[0_0_0_3px_rgba(168,85,247,0.25)]' : 'border-gray-300'}
        `}
            />

            {/* Label */}
            <label
                className={`
          absolute left-4 px-1 bg-white
          transition-all duration-200 pointer-events-none
          ${isFloating ? '-top-2.5 text-xs text-purple-600' : 'top-3 text-gray-500'}
        `}>
                {label}
            </label>
            {isPassword && (!visible ? <EyeClosed className="transition-colors duration-500 hover:text-purple-500 absolute inset-x-[90%] inset-y-1/4 text-gray-400 font-thin" onClick={() => setVisible(prev => !prev)} /> : <Eye className="transition-colors duration-500 hover:text-purple-500 absolute inset-x-[90%] inset-y-1/4 text-gray-400 font-thin" onClick={() => setVisible(prev => !prev)} />)}
        </div>
    );
};

export default FloatingInput;
